export default __webpack_public_path__ + "static/media/023-cathedral of brasilia.e2c4d6b7.svg";